import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";

// Since DOM elements <a> cannot receive activeClassName
// and partiallyActive, destructure the prop here and
// pass it only to GatsbyLink
/**
 * @param {Omit<import("gatsby").GatsbyLinkProps, "ref">} props
 */
const Link = ({
  children,
  to,
  activeClassName,
  activeStyle,
  partiallyActive,
  ...other
}) => {
  if (!to) {
    return <>{children}</>;
  }

  // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.
  const internal = /^\/(?!\/)/.test(to);

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <GatsbyLink
        to={to}
        activeClassName={activeClassName}
        partiallyActive={partiallyActive}
        activeStyle={activeStyle}
        {...other}
      >
        {children}
      </GatsbyLink>
    );
  }
  return (
    <OutboundLink href={to} {...other}>
      {children}
    </OutboundLink>
  );
};

export default Link;
